<template>
  <table class="table">
    <thead>
      <tr>
        <th>Title</th>
        <th>Assigned to</th>
        <th>Status</th>
        <th>Priority</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="task in $store.state.tasks">
        <td>
          <a :href="`/projects/${task.project.id}/tasks/${task.taskNumber}`">
            {{task.summary}}
          </a>
        </td>
        <td>
          <span v-if="task.assignee">
            {{task.assignee.fullname}}
          </span>
          <span v-else>
            Unassigned
          </span>
        </td>
        <td>
          <span class="badge" :class="'badge-' + task.htmlStatus.class">
            {{task.htmlStatus.name}}
          </span>
        </td>
        <td>
          <span class="badge" :class="'badge-' + task.htmlPriority.class">
            {{task.htmlPriority.name}}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
 export default {
   created() {
     this.$store.dispatch('loadTasks', {
       projectId: this.$store.state.currentProject.id,
     });
   },

   methods: {
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/TaskList.vue